import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { isLoggedIn } from "../../helper/utility";
import { hideAds} from "../../common/actions/userAccount";
import "./AdsViewStyle.css";
import {
  getParentAdvertList,
} from "../../common/actions/ads";
class AdsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentAdIndex: 0,
      displayAds: true,
    };
  }

  componentDidMount() {
    if(isLoggedIn()) {
      this.props.doHideAds({
        displayAds: false,
      });
      setTimeout(this.getAds, 5000);}
  }

  componentWillUnmount() {

    if (this.adsLoop) {
      clearInterval(this.adsLoop);
      this.adsLoop = null;
    }
  }

  getAds = () => {
    const { doGetParentAdvertList, schoolInfo } = this.props;
    const SchoolIDs = [];
    schoolInfo &&
      schoolInfo.forEach((element) => {
        SchoolIDs.push(element.SchoolID);
      });
    doGetParentAdvertList({ SchoolIDs });
  };

  showAds = () => {
    //console.log("showAds called")
    let { currentAdIndex } = this.state;
    const { adsList } = this.props;
    if (adsList && adsList.Ads.length > 0) {
      if (currentAdIndex < adsList.Ads.length - 1) {
        currentAdIndex++;
      } else {
        currentAdIndex = 0;
      }
      this.setState({ currentAdIndex });
    }
  };

  componentDidUpdate() {
    const { adsList } = this.props;
    //console.log("this.adsLoop  ", this.adsLoop )
    if (!this.adsLoop && adsList && adsList.Ads.length > 0) {
      this.adsLoop = setInterval(this.showAds, adsList.AdIntervalMS);
      this.props.showAds(true);
      this.props.doHideAds({
        displayAds: true,
      });
    }
  }


  render() {
    const { adsList } = this.props;
    let { currentAdIndex, displayAds } = this.state;

    return displayAds && adsList && adsList.Ads.length > 0 ? (
      <div className="pmkAdsSection">
        <figure className="AdsImages">
          <button type="button" className="adclose-btn"
            onClick={() => {
              this.setState({ displayAds: false });
              this.props.showAds(false);
              this.props.doHideAds({
                displayAds: false,
              });
            }}
			aria-label={this.props.t('Close_Button')}

          ><i className="fa-solid fa-xmark"></i></button>
          <img
            src={adsList.Ads[currentAdIndex].ImageUrl}
            alt="Ads"
            title="Ads"
          />
        </figure>

      </div>
    ) : (<></>);
  }
}

function mapStateToProps(state) {
  return {
    schoolInfo: state.student.schoolInfo,
    adsList: state.ads.adsList,
    displayAds : state.userAccount.displayAds,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    doGetParentAdvertList: (data) => dispatch(getParentAdvertList(data)),
    doHideAds: (data) => dispatch(hideAds(data)),
  };
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(AdsView)
);
